<template>
  <div>
    <Create 
      :id="$route.params.id"
      :tid="$route.params.tid"
      @created="redirect"
    />
  </div>
</template>

<script>
import Create from '@/components/taxes/Create'

export default {
  methods: {
    redirect () {
      this.$router.push({ name: 'Contract', id: this.$route.params.id })
    }
  },

  components: {
    Create
  },
}
</script>
